import React from 'react';
export function ProblemSection() {
  return <section className="relative bg-neutral-bg py-8 px-4 sm:px-6 lg:px-8 overflow-hidden border-y border-neutral-beige" data-id="element-119">
      <div className="absolute -right-20 top-10 w-64 h-64 border-[40px] border-white rounded-full opacity-30 pointer-events-none" data-id="element-120"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-121">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A] mb-4 leading-tight" data-id="element-122">
          🧠 Déjame preguntarte algo…
        </h2>

        <p className="text-base sm:text-lg text-gray-600 mb-3 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-123">
          ¿Te gustaría comer más saludable… pero sientes que no sabes por dónde
          empezar?
        </p>

        <p className="text-base sm:text-lg text-gray-600 mb-6 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-124">
          Compras verduras… no sabes realmente cómo fueron cultivadas… y cada
          vez todo es más caro.
        </p>

        <div className="relative inline-block" data-id="element-125">
          <div className="absolute inset-0 bg-earth-accent/5 transform -skew-x-12 rounded-2xl" data-id="element-126"></div>
          <div className="relative text-xl sm:text-2xl font-black text-earth-accent p-5 sm:p-6 bg-white rounded-2xl border-l-8 border-earth-accent shadow-xl" data-id="element-127">
            👉 "Me gustaría producir mi propia comida… pero no es para mí."
          </div>
        </div>
      </div>
    </section>;
}